import React, { useState } from 'react'
import MoreButton from '../components/MoreButton'
import SymbolHeading from '../components/SymbolHeading'
import Teaser from '../components/Teaser'
import NotesList from '../assets/notes-list.svg?svgr-webpack'
import { runQuery } from 'js/dato'
import {
  allStoriesQuery,
  recipesDataQuery,
} from 'js/pages/NutritionExplained/queries/categoryQuery'
import Spinner from 'js/components/Spinner/Spinner'
import RecipeTeaser from '../components/RecipeTeaser'

type Props = {
  initialEntries: any[]
  category: {
    id: 'recipes' | 'category'
    recipeCount?: number
    storyCount?: number
  }
  showHeading: boolean
  type: 'recipes' | 'stories'
}

export default function CategoryListing({
  category,
  initialEntries,
  showHeading = true,
  type,
}: Props) {
  const [allEntries, setAllEntries] = useState(initialEntries)
  const [loading, setLoading] = useState(false)

  const loadMoreStories = () => {
    setLoading(true)

    const finish = (newEntries) => {
      setAllEntries(allEntries.concat(newEntries))
      setLoading(false)
    }

    if (type === 'stories') {
      runQuery(allStoriesQuery, {
        id: category.id,
        skip: allEntries.length,
      }).then(({ allStories: newEntries }) => finish(newEntries))
    } else {
      runQuery(recipesDataQuery, {
        skip: allEntries.length,
      }).then(({ allRecipes: newEntries }) => finish(newEntries))
    }
  }

  if (allEntries.length === 0) return null

  const totalCount = (
    type === 'recipes' ? category.recipeCount : category.storyCount
  ) as number

  return (
    <div className="o-width-limiter">
      {showHeading && (
        <SymbolHeading symbol={NotesList}>All stories</SymbolHeading>
      )}
      {type === 'recipes' ? (
        <div className="mb-32 grid gap-8 md:grid-cols-2 lg:mb-40 lg:grid-cols-3 lg:gap-6 xl:mb-64 xl:gap-10">
          {allEntries.map((recipe) => (
            <RecipeTeaser
              key={recipe.id}
              {...recipe}
              sizes="(min-width: 1650px) 440px, (min-width: 1000px) 30vw, (min-width: 600px) 40vw, 100vw"
            />
          ))}
        </div>
      ) : (
        <div className="flex-wrap md:flex">
          {allEntries.map((story) => {
            return (
              <div key={story.id} className="mb-32 lg:mb-40 lg:w-1/2 xl:mb-64">
                <div className="md:mx-16 lg:mx-24 xl:mx-32">
                  <Teaser {...story} />
                </div>
              </div>
            )
          })}
        </div>
      )}
      <div className="text-center">
        {allEntries.length < totalCount && (
          <MoreButton
            arrow={!loading}
            onClick={loadMoreStories}
            disabled={loading}
          >
            {loading ? (
              <Spinner
                width="14"
                color="Type"
                className="relative"
                style={{ top: 1 }}
              />
            ) : (
              'Load more'
            )}
          </MoreButton>
        )}
        <p className="type-nano mt-12 text-grey">
          Showing {allEntries.length} of a total of {totalCount} {type}.
        </p>
      </div>
    </div>
  )
}
